export default {
  flagIcon: {
    width: 32,
    height: 16,
  },
};
